import { Brand } from "./Brand";

const COLUMNS = [
  {
    title: "Productos",
    links: [
      { label: "TUPU Stock", href: "https://stock.tupu.cl", id: "stock" },
      { label: "TUPU Calidad", href: "https://calidad.tupu.cl", id: "calidad" },
      { label: "TUPU Personas", href: "https://personas.tupu.cl", id: "personas" },
    ],
  },
  {
    title: "Empresa",
    links: [{ label: "Contacto", href: "mailto:contacto@tupu.cl", id: "contacto" }],
  },
  {
    title: "Legal",
    links: [
      { label: "Términos", href: "#", id: "terminos" },
      { label: "Privacidad", href: "#", id: "privacidad" },
    ],
  },
];

export const Footer = () => (
  <footer id="contacto" data-testid="site-footer" className="bg-[#1F3D35] text-[#F3EBD7]">
    <div className="mx-auto max-w-7xl px-6 py-16 md:px-12 md:py-20">
      <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <Brand variant="light" />
          <p className="mt-5 max-w-xs text-sm font-light leading-relaxed text-[#F3EBD7]/60" data-testid="footer-slogan">
            Mide. Registra. Cumple.
          </p>
        </div>

        {COLUMNS.map(({ title, links }) => (
          <div key={title} className="md:col-span-2">
            <h3 className="mb-5 text-xs font-bold uppercase tracking-[0.2em] text-[#C6F04A]/80">{title}</h3>
            <ul className="space-y-3">
              {links.map(({ label, href, id }) => (
                <li key={id}>
                  <a
                    href={href}
                    data-testid={`footer-link-${id}`}
                    {...(href.startsWith("http") ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    className="text-sm font-light text-[#F3EBD7]/70 transition-colors hover:text-[#C6F04A]"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-16 flex flex-col gap-3 border-t border-[#F3EBD7]/10 pt-8 text-xs text-[#F3EBD7]/45 md:flex-row md:items-center md:justify-between">
        <span data-testid="footer-copyright">© 2026 TUPU</span>
        <span>tupu.cl</span>
      </div>
    </div>
  </footer>
);
